import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import SEO from '../components/SEO';
import { SEONavbar, SEOFooter } from '../components/SEOLayout';
import PublicChatWidget from '../components/PublicChatWidget';
import { getAllPosts } from '../data/blogPosts';

const BloggPage = () => {
  const posts = getAllPosts();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F7F4EF' }}>
      <SEO
        title="Operio Blogg — guider om digitalisering & AI i byggbranschen"
        description="Praktiska artiklar för bygg-, mark- och entreprenadföretag. Lär dig kalkylera snabbare, automatisera tidrapportering och växa lönsamt med AI."
        canonical="/blogg"
        keywords="bygg blogg sverige, AI i byggbranschen, digitalisering bygg, kalkylguide bygg"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: 'Operio Blogg',
          url: 'https://operio.nu/blogg',
          publisher: { '@type': 'Organization', name: 'Operio AB' },
        }}
      />
      <SEONavbar activePage="blogg" />

      <main className="pt-24 sm:pt-28 pb-20">
        <section className="px-5 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-sm font-medium text-[#E8613A] uppercase tracking-widest mb-3">Operio Blogg</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1A1A1A] leading-[1.05]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
              Guider för moderna byggare
            </h1>
            <p className="text-base text-[#6B6560] mt-5 max-w-xl mx-auto leading-relaxed">
              Konkreta artiklar om AI, digitalisering och hur du växer en lönsam byggverksamhet.
            </p>
          </div>
        </section>

        <section className="px-5 sm:px-6 mt-14 sm:mt-20">
          <div className="max-w-4xl mx-auto space-y-5">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blogg/${p.slug}`}
                className="group block bg-white border border-[#E8E2D9] rounded-2xl p-6 sm:p-8 hover:border-[#E8613A]/40 hover:shadow-lg transition-all"
                data-testid={`post-${p.slug}`}
              >
                <p className="text-xs font-bold uppercase tracking-wider text-[#E8613A]">{p.category}</p>
                <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mt-2 group-hover:text-[#E8613A] transition-colors" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
                  {p.title}
                </h2>
                <p className="text-sm text-[#6B6560] mt-2 leading-relaxed">{p.excerpt}</p>
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-4 text-xs text-[#7A7570]">
                  <span className="inline-flex items-center gap-1"><Calendar size={11} /> {new Date(p.date).toLocaleDateString('sv-SE', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                  <span className="inline-flex items-center gap-1"><Clock size={11} /> {p.readMinutes} min läsning</span>
                  <span className="inline-flex items-center gap-1 ml-auto text-[#E8613A] font-medium">Läs artikel <ArrowRight size={11} /></span>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>

      <SEOFooter />
      <PublicChatWidget />
    </div>
  );
};

export default BloggPage;
